"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["as", "gutters", "equalHeight", "justifyContent", "alignItems", "sm", "md", "lg", "xl", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var classNameBySize = function classNameBySize(prop, value, size) {
  return !!value && "".concat(prop).concat(size ? "-".concat(size) : "", "-").concat(value);
};

var rowClasses = function rowClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems;

  var size = arguments.length > 1 ? arguments[1] : undefined;
  return [classNameBySize("justify-content", justifyContent, size), classNameBySize("align-items", alignItems, size)];
};

var Row = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var as = props.as,
      gutters = props.gutters,
      equalHeight = props.equalHeight,
      justifyContent = props.justifyContent,
      alignItems = props.alignItems,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = _classnames["default"].apply(void 0, [className, "row", !gutters && "no-gutters", equalHeight && "equal-cols"].concat(_toConsumableArray(rowClasses({
    justifyContent: justifyContent,
    alignItems: alignItems
  })), _toConsumableArray(rowClasses(sm, "sm")), _toConsumableArray(rowClasses(md, "md")), _toConsumableArray(rowClasses(lg, "lg")), _toConsumableArray(rowClasses(xl, "xl"))));

  var Component = as;
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: ref
  }, otherProps));
});

var justifyContentType = _propTypes["default"].oneOf(["start", "end", "center", "between", "around"]);

var alignItemsType = _propTypes["default"].oneOf(["start", "end", "center", "between", "around", "stretch"]);

var sizeType = _propTypes["default"].shape({
  justifyContent: justifyContentType,
  alignItems: alignItemsType
});

Row.propTypes = {
  /** Styles the Row using the `align-items` CSS property for flexbox. */
  alignItems: alignItemsType,

  /** Sets the height of the children columns to be equal. */
  equalHeight: _propTypes["default"].bool,

  /** Can be set to false to row the gutters from the Row. */
  gutters: _propTypes["default"].bool,

  /** Styles the Row using the `justify-content` CSS property for flexbox. */
  justifyContent: justifyContentType,

  /** Set the justifyContent and alignItems properties for the small breakpoint. */
  sm: sizeType,

  /** Set the justifyContent and alignItems properties for the medium breakpoint. */
  md: sizeType,

  /** Set the justifyContent and alignItems properties for the large breakpoint. */
  lg: sizeType,

  /** Set the justifyContent and alignItems properties for the extra large breakpoint. */
  xl: sizeType,

  /** Changes the HTML element of the Row. */
  as: _propTypes["default"].elementType,

  /** Extra classes for the Row. */
  className: _propTypes["default"].string
};
Row.defaultProps = {
  as: "div",
  gutters: true,
  equalHeight: false
};
Row.displayName = "Row";
var _default = Row;
exports["default"] = _default;